var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          attrs: {
            loading: _vm.isRemoteLoading,
            "remote-method": _vm.onRemoteM,
            filterable: "",
            clearable: "",
            placeholder: _vm.placeholder,
            remote: "",
          },
          on: { clear: _vm.onClearSelect },
          model: {
            value: _vm.selectValue,
            callback: function ($$v) {
              _vm.selectValue = $$v
            },
            expression: "selectValue",
          },
        },
        _vm._l(_vm.selectDataList, function (itemData, index) {
          return _c("el-option", {
            key: index,
            attrs: {
              label: itemData[_vm.labelKey],
              value: itemData[_vm.valueKey],
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }